// extracted by mini-css-extract-plugin
export var fullWidthButton = "_r8-0";